import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import {
  getTitleContentRevealDelayMs,
  StepMotionGroup,
  StepMotionItem,
} from "./step-motion";
import { StepTitle } from "./step-title";
import type { ConciergePhoneStatus } from "./types";

export interface CompletionStepProps {
  animateItems?: boolean;
  activationPhoneStatus: ConciergePhoneStatus | null;
}

export const CompletionStep = memo(function CompletionStep({
  animateItems,
  activationPhoneStatus,
}: CompletionStepProps) {
  const title = "Playbook setup complete";
  const contentRevealDelayMs = getTitleContentRevealDelayMs(title);
  const subtitle =
    activationPhoneStatus === "approved"
      ? "Set up a Start Agent Conversation step in Automations to begin outreach."
      : "Your sending number is being reviewed. Set up a Start Agent Conversation step in Automations now; outreach can start when the number is ready.";

  return (
    <StepMotionGroup animateItems={animateItems}>
      <Flex dir="column" gap="lg">
        <StepMotionItem animateItems={animateItems}>
          <Text fontSize="sm" textColor="tertiary">
            All done
          </Text>
        </StepMotionItem>
        <StepMotionItem animateItems={animateItems}>
          <StepTitle animate={animateItems} text={title} />
        </StepMotionItem>
        <StepMotionItem
          animateItems={animateItems}
          delayMs={contentRevealDelayMs}
        >
          <Text fontSize="lg" textColor="tertiary">
            {subtitle}
          </Text>
        </StepMotionItem>
      </Flex>
    </StepMotionGroup>
  );
});
